'use strict';

const { isEmpty } = require('lodash');
const { isRegexPatternValid } = require('richemont/libs/utils');
require('richemont/components/input');

/**
 *
 * @param {HTMLElement} el input
 * @returns {string} msg error
 */
function getFormValidationMsgError(el) {
    const $el = $(el);
    const elContent = $el.val();
    if (el.validity.valueMissing || isEmpty(elContent)) {
        return $el.attr('data-missing-error');
    }

    const minLength = parseInt($el.attr('minLength'), 10);
    if (elContent.length < minLength) {
        return $el.attr('data-range-error');
    }

    if ($el.attr('pattern') && elContent.length >= minLength) {
        if (el.validity.patternMismatch || !isRegexPatternValid($el.attr('pattern'), elContent)) {
            return $el.attr('data-pattern-mismatch');
        }
    }

    return '';
}

$(() => {
    const $document = $(document);

    $document.off('keyup focusout').on('keyup focusout', 'input[type="text"], input[type="password"]', function () {
        const $this = $(this);

        // Clear custom errors
        $this.closest('.form-element').removeClass('has-custom-error').find('.error-text.custom-error').text('');

        let errMsg = getFormValidationMsgError(this);
        let isErrorMessage = !isEmpty(errMsg);
        const $invalidFb = $this.closest('.input-text-wrapper').find('.invalid-feedback');
        const $inputWrapper = $this.closest('.input-field');
        const iconCheck = $inputWrapper.find('.icon-check').length;
        const iconHTML = '<span class="icon icon-check icon-size-s"></span>';
        const isPasswordConfirm = $this.is('#registration-form-password-confirm');

        if (isPasswordConfirm) {
            const isPasswordConfirmValid = $this.val() === $('#registration-form-password').val();

            if (!isPasswordConfirmValid) {
                errMsg = $this.data('range-error');
                isErrorMessage = true;
            }
            this.setCustomValidity(isPasswordConfirmValid ? '' : 'invalid');
        }

        if (!iconCheck) {
            $inputWrapper.append(iconHTML);
        }

        if (isErrorMessage) {
            $invalidFb.text(errMsg);
            $this.addClass('is-invalid');
            $inputWrapper.removeClass('valid');
        } else {
            $invalidFb.empty();
            $this.removeClass('is-invalid');
            $inputWrapper.addClass('valid');
        }
    });

    $(document).on('change', '.custom-select', function () {
        let $this = $(this);
        if ($this.hasClass('is-invalid') && $this.val !== '') {
            $this.removeClass('is-invalid');
            $this.closest('.form-element').find('.invalid-feedback').empty();
        }
    });

    // Remove error message once radio is selected
    $document.on('click', '[name$=title]', function () {
        $(this).closest('.form-element').find('.invalid-feedback').empty();
    });
});
